/**
 * Русское склонение существительного по числу.
 * @param count число
 * @param forms [одна, две, пять] — например ['отзыв', 'отзыва', 'отзывов']
 */
export const pluralRu = (
  count: number,
  forms: [string, string, string],
): string => {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return forms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return forms[1];
  }
  if (n1 === 1) {
    return forms[0];
  }
  return forms[2];
};

/** «128 отзывов», «1 отзыв», «3 отзыва» */
export const formatReviewsCount = (count: number): string =>
  `${count} ${pluralRu(count, ['отзыв', 'отзыва', 'отзывов'])}`;
